/**
 * Each action represents a GA event's with category, label, and action name
 */
export const actions = {
  assistance: {
    action: 'clic_assistance',
    category: 'lost_app',
    label: 'picto_assistance',
  },
  // Step 1 - Login events
  login: {
    action: 'clic_continuer_login',
    category: 'lost_login',
    label: 'bouton_login_continuer',
  },
  helpLogin: {
    action: 'clic_help_login',
    category: 'lost_login',
    label: 'picto_help_login',
  },
  HelpNsru: {
    action: 'clic_consigne_nsru',
    category: 'lost_login',
    label: 'picto_consigne_NSRU',
  },
  endNsru: {
    action: 'clic_terminer_nsru',
    category: 'lost_login',
    label: 'bouton_login_terminer_NSRU',
  },
  loginInvalid: {
    action: 'clic_continuer_login',
    category: 'lost_login',
    label: 'erreur_mail_invalide',
  },
  loginUnknown: {
    action: 'clic_continuer_login',
    category: 'lost_login',
    label: 'erreur_mail_inconnu',
  },
  captchaUnfinished: {
    action: 'clic_continuer_login',
    category: 'lost_login',
    label: 'erreur_captcha_non_fini',
  },
  captchaInvalid: {
    action: 'clic_continuer_login',
    category: 'lost_login',
    label: 'erreur_captcha_invalide',
  },
  // Step 2 - Contact choice events
  helpCanal: {
    action: 'clic_help_canal',
    category: 'lost_canal',
    label: 'picto_canal_help',
  },
  resetByMail: {
    action: 'clic_canal_mail',
    category: 'lost_canal',
    label: 'chevron_canal_mail',
  },
  resetBySms: {
    action: 'clic_canal_sms',
    category: 'lost_canal',
    label: 'chevron_canal_sms ',
  },
  noContactLink: {
    action: 'clic_lien_nocontact',
    category: 'lost_canal',
    label: 'lien_canal_aucun_contact ',
  },
  getLetter: {
    action: 'clic_recevoir_courrier',
    category: 'lost_canal',
    label: 'bouton_recevoir_courrier ',
  },
  // Step 2 - Letter choice events
  helpPostalCode: {
    action: 'clic_help_code_reinit',
    category: 'lost_courrier',
    label: 'lien_help_code_reinit ',
  },
  sendLetter: {
    action: 'clic_valider_codepostal',
    category: 'lost_courrier',
    label: 'bouton_valider_codepostal',
  },
  endLetter: {
    action: 'clic_envoi_courrier_terminer',
    category: 'lost_courrier',
    label: 'bouton_terminer_envoi',
  },
  // Step 3 - One time code events
  helpOtc: {
    action: 'clic_help_code',
    category: 'lost_code',
    label: 'picto_help_code',
  },
  retryCode: {
    action: 'clic_renvoi_code',
    category: 'lost_code',
    label: 'lien_code_renvoi ',
  },
  checkCode: {
    action: 'clic_continuer_code',
    category: 'lost_code',
    label: 'bouton_code_continuer ',
  },
  // Step 4 - Update password events
  helpPassword: {
    action: 'clic_help_pwd',
    category: 'lost_password',
    label: 'picto_pwd_help ',
  },
  showPassword: {
    action: 'clic_affich_pwd_crea',
    category: 'lost_password',
    label: 'picto_pwd_crea_afficher ',
  },
  showPasswordConfirm: {
    action: 'clic_affich_pwd_confirm',
    category: 'lost_password',
    label: 'picto_pwd_confirm_afficher ',
  },
  updatePassword: {
    action: 'clic_valider_pwd',
    category: 'lost_password',
    label: 'pwd_valider ',
  },
  // Step 5 - Add contacts events
  checkedNoMail: {
    action: 'clic_valider',
    category: 'lost_add_contact',
    label: 'aucun_mail ',
  },
  checkedNoMobile: {
    action: 'clic_valider',
    category: 'lost_add_contact',
    label: 'aucun_mobile ',
  },
  checkedBoth: {
    action: 'clic_valider',
    category: 'lost_add_contact',
    label: 'aucun_mail_ni_mobile ',
  },
  // Step 6 - Add contacts events
  helpMessaging: {
    action: 'clic_registr_maj_cpte',
    category: 'lost_registration',
    label: 'lien_registr_maj_compte ',
  },
  account: {
    action: 'clic_registr_modif_cpte',
    category: 'lost_registration',
    label: 'lien_registr_modif_compte ',
  },
  phishingInfo: {
    action: 'clic_registr_phishing',
    category: 'lost_registration',
    label: 'lien_registr_phishing ',
  },
  auth: {
    action: 'clic_registr_sidentifier',
    category: 'lost_registration',
    label: 'bouton_registr_sidentifier ',
  },
  // Error page events
  technicalError: {
    action: 'erreur_technique_bloquante',
    category: 'lost_erreur_tech',
    label: 'erreur_tech_bloquante ',
  },
  noJavascript: {
    action: 'erreur_technique_java',
    category: 'lost_erreur_tech',
    label: 'erreur_tech_java ',
  },
};

export const screens = {
  ident: {
    name: 'login',
  },
  captcha: {
    name: 'captcha',
  },
  choice: {
    name: 'canal',
  },
  letter: {
    name: 'canal_courrier',
  },
  otc: {
    name: 'code',
  },
  password: {
    name: 'password',
  },
  contact: {
    name: 'ajout_contacts',
  },
  confirm: {
    name: 'registration',
  },
  error: {
    name: 'erreur_technique',
  },
};
